import { createAction, props } from '@ngrx/store';
import { Faq } from './faqs.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records faqs'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records faqs success', 
    props<{ listData: Faq[] }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records faqs failure', 
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state faq',
);